<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Processos"
      Pagina="Processo"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
            <div class="row">
              <div class="col-md-12 text-right" style="margin-bottom: 10px;">
                <button (click)="abrirModalNovoProcesso()" class="btn btn-primary"><i class="fa fa-plus"></i> Cadastrar</button>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-12">
                    <div class="card card-blue">
                      <div class="card-header">
                        <h3 class="card-title">Lista de Processos/Casos</h3>
                        <div class="card-tools">

                          <div class="input-group input-group-sm" style="width: 350px;">
                            <input type="text" name="table_search" (keydown)="filtrar()" [(ngModel)]="filtro" class="form-control float-right" placeholder="Digite para buscar o processo">
                            <div class="input-group-append">
                              <button (click)="limparFiltro()" class="btn btn-danger">
                                <i class="fa fa-eraser"></i>
                              </button>
                              <button (click)="filtrar()" class="btn btn-default">
                                <i class="fa fa-search"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-body table-responsive p-0">
                        <table class="table table-hover table-striped text-nowrap table-sm">
                          <thead>
                          <tr>
                            <th colspan="5" class="text-center" style="font-size: 16px;">Pastas de processos</th>
                          </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let grupo of processosAgrupados | paginate: { itemsPerPage: 10, currentPage: paginaAtual }">
                              <tr (click)="togglePasta(grupo)" style="cursor: pointer; background-color: #f4f6f9;">
                                <td colspan="5"  style="font-size: 13px;">
                                  <i class="fa" [ngClass]="grupo.aberta ? 'fa-folder-open' : 'fa-folder'"></i>
                                  <strong class="ml-2"> {{grupo.pasta}} </strong>
                                  <span class="badge badge-primary ml-2">{{grupo.processos.length}} processos</span>
                                </td>
                              </tr>
                              <ng-container *ngIf="grupo.aberta">
                                <tr style="font-size: 11px;background-color: #f8f9fa; font-weight: bold;">
                                  <td style="padding-left: 30px;">Titulo</td>
                                  <td>Tipo Ação</td>
                                  <td>Ultima Movimentacao</td>
                                  <td>Status</td>
                                  <td></td>
                                </tr>
                                <tr *ngFor="let linha of grupo.processos" (click)="abrirDetalhes(linha.id)" style="cursor: pointer;">
                                  <td style="padding-left: 30px;">
                                    <i class="fa fa-file-pdf-o"></i>
                                    <b>{{linha.numero}}</b> - {{linha.titulo}}
                                  </td>
                                  <td>{{linha.acao}}</td>
                                  <td>{{linha.ultimaMovimentacao | date:"dd/MM/yyyy" }}</td>
                                  <td>
                                    <span class="badge" [ngClass]="{
                                      'badge-primary': linha.status == 0,
                                      'badge-info': linha.status == 1,
                                      'badge-success': linha.status == 2,
                                      'badge-warning': linha.status == 3,
                                      'badge-danger': linha.status == 4
                                    }">
                                      {{getStatusDescricao(linha.status)}}
                                    </span>
                                  </td>
                                  <td style="text-align: right;">
                                    <button class="btn btn-light btn-xs" (click)="$event.stopPropagation()" [routerLink]="['/juridico/processo/visualizar', linha.id]"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-primary btn-xs" (click)="$event.stopPropagation()" [routerLink]="['/juridico/processo/detalhes', linha.id]"><i class="fa fa-pencil"></i></button>
                                    <button class="btn btn-danger btn-xs" (click)="$event.stopPropagation()"><i class="fa fa-trash"></i></button>
                                  </td>
                                </tr>
                              </ng-container>
                            </ng-container>
                          </tbody>
                          <tfoot>
                            <tr class="text-center">
                              <td [attr.colspan]="5">
                                <pagination-controls
                                    class="pagination-sm"
                                   [autoHide]="false"
                                   [directionLinks]="true"
                                   previousLabel="Anterior"
                                   nextLabel="Próximo"
                                   (pageChange)="pageChange($event)">
                                </pagination-controls>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </div>
  </section>
</div>

<app-novo-processo [isModal]="true" (atualizarLista)="buscarListaProcessos()"></app-novo-processo>


